export const sitesWebMisc = {
  // NombreEditable.vue — inline-editable website name field
  ne: {
    aria: "Il nome del tuo sito web",
    placeholder: "Il mio alloggio",
    hint: "Invio per salvare · Esc per annullare",
  },

  // website/index.vue — website creation wizard
  website: {
    next: "Avanti",
  },

  // Notificaciones/index.vue — notifications timeline
  notif: {
    title: "Notifiche",
    subtitle: "Tutto ciò che è successo nei tuoi alloggi, in ordine cronologico.",
    // Filters
    filterAll: "Tutte",
    filterBookings: "Prenotazioni",
    filterCheckins: "Check-in",
    filterServices: "Servizi",
    filterPayments: "Pagamenti",
    // Empty state
    emptyAll: "Ancora nessuna notifica",
    emptyFilter: "Nessuna notifica in questo filtro",
    emptyBody:
      "Quando succede qualcosa con le tue prenotazioni —una nuova, un check-in, un pagamento— comparirà qui.",
    // Day separators
    noDate: "Nessuna data",
    today: "Oggi",
    yesterday: "Ieri",
    // Event status (left column)
    stNueva: "Nuova",
    stActualizada: "Aggiornata",
    stCancelada: "Annullata",
    stRealizado: "Completato",
    stSolicitado: "Richiesto",
    stRecibida: "Ricevuta",
    stAprobada: "Approvata",
    stRechazada: "Rifiutata",
    stConfirmado: "Confermato",
    stEnProceso: "Pagamento in corso",
    stAviso: "Avviso",
    // Event category (subtitle)
    catReserva: "prenotazione",
    catCheckin: "check-in",
    catServicio: "servizio",
    catSolicitud: "richiesta",
    catPago: "pagamento",
    catPagoPendiente: "pagamento in sospeso",
    catSistema: "sistema",
    // Descriptive event-type labels
    lbNuevaReserva: "Nuova prenotazione",
    lbReservaActualizada: "Prenotazione aggiornata",
    lbReservaCancelada: "Prenotazione annullata",
    lbCheckin: "Check-in",
    lbServicio: "Servizio",
    lbSolicitud: "Richiesta",
    lbSolicitudAprobada: "Richiesta approvata",
    lbSolicitudRechazada: "Richiesta rifiutata",
    lbPago: "Pagamento",
    lbNotificacion: "Notifica",
  },

  // Integrations/index.vue — integrations with external services
  integrations: {
    title: "Integrazioni",
    subtitle: "Collega servizi esterni per semplificare la gestione",
    descPricelabs: "Ottimizzazione dinamica dei prezzi",
    descStripe: "Pagamenti con carta dagli ospiti",
    descWompi: "Pagamenti degli ospiti in Colombia",
    connected: "Collegato",
    disconnected: "Non collegato",
  },
};
